module.exports = __webpack_public_path__ + "img/more_square.86dab0cb.svg";